import { EmptyNoneIcon } from '@/icons/Empty/emptyNone'
import { Empty } from 'antd'
import { useTranslation } from 'react-i18next'
import './index.css'

/**
 * 空状态组件（无数据版本）
 *
 * 这是一个专门用于显示"暂无数据"状态的空状态组件，使用自定义的EmptyNoneIcon图标。
 * 相比通用的ListEmpty组件，这个组件专门针对无数据场景进行了优化。
 *
 * @param props - 其他传递给Empty组件的属性
 *
 * 使用场景：
 * 1. 数据列表空状态 - 表格、列表无数据时的展示
 * 2. 搜索结果空状态 - 搜索无结果时的提示
 * 3. 筛选结果空状态 - 筛选条件无匹配结果时
 * 4. 收藏夹空状态 - 收藏列表为空时的提示
 * 5. 历史记录空状态 - 历史记录为空时的展示
 * 6. 消息列表空状态 - 消息列表为空时的提示
 * 7. 文件列表空状态 - 文件列表为空时的展示
 * 8. 任务列表空状态 - 任务列表为空时的提示
 *
 * 使用示例：
 * ```tsx
 * // 基础用法
 * <ListEmptyNone />
 *
 * // 在表格中使用
 * <Table
 *   dataSource={[]}
 *   locale={{ emptyText: <ListEmptyNone /> }}
 * />
 *
 * // 在列表中使用
 * {data.length === 0 ? (
 *   <ListEmptyNone />
 * ) : (
 *   <List data={data} />
 * )}
 *
 * // 带自定义属性
 * <ListEmptyNone
 *   style={{ marginTop: 20 }}
 *   description="自定义描述"
 * />
 * ```
 */
const ListEmptyNone = (props: any) => {
  // 国际化翻译函数（虽然当前未使用，但保留以备将来扩展）
  const { t } = useTranslation()
  return (
    <Empty
      image={<EmptyNoneIcon />} // 使用自定义的无数据图标
      description={
        <div className="lenovo-list-empty-content">
          <span className="lenovo-list-empty-title-none">暂无数据</span>
        </div>
      }
      className="lenovo-list-empty" // 应用自定义样式类
      {...props} // 传递其他属性
    />
  )
}

export default ListEmptyNone
